import type { LeaderboardBoard, LeaderboardScope, LeaderboardPeriod } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The board for the given scope (own federation or global) and period (all-time, or a calendar
// window): the top slice, the caller's own standing when they fall below it, and the total ranked
// count. Ordered server-side by xp desc, streak desc.
export async function getLeaderboard(
  scope: LeaderboardScope,
  period: LeaderboardPeriod,
): Promise<LeaderboardBoard> {
  const res = await api.get<Envelope<LeaderboardBoard>>('/leaderboard', { params: { scope, period } });
  return unwrap(res.data);
}
